import { create } from 'zustand';
import axios from 'axios';

export const useNotificationsStore = create((set) => ({
  notificationsUnread: 0,

  loadNotificationsCount: async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      set(() => ({ notificationsUnread: 0 }));
      return;
    }

    try {
      const res = await axios.get('/api/v1/user/notifications/count', {
        headers: { Authorization: token },
      });
      if (res.data?.data?.unread != null) {
        set(() => ({ notificationsUnread: res.data.data.unread }));
      }
    } catch {
      set(() => ({ notificationsUnread: 0 }));
    }
  },

  setNotificationsUnread: (unread) => {
    set(() => ({ notificationsUnread: unread }));
  },
}));
